// Hindi — shared key set with the Flutter apps (lib/l10n).
// Auto-generated from the Dart source of truth; keep both in sync.
// Flat, dotted keys — i18n is configured with keySeparator:false.

const hi: Record<string, string> = {
  "common.save": "सहेजें",
  "common.cancel": "रद्द करें",
  "common.delete": "हटाएँ",
  "common.edit": "संपादित करें",
  "common.add": "जोड़ें",
  "common.close": "बंद करें",
  "common.back": "वापस",
  "common.done": "हो गया",
  "common.yes": "हाँ",
  "common.no": "नहीं",
  "common.confirm": "पुष्टि करें",
  "common.search": "खोजें",
  "common.retry": "पुनः प्रयास करें",
  "common.loading": "लोड हो रहा है…",
  "common.offline": "ऑफ़लाइन",
  "nav.settings": "सेटिंग्स",
  "nav.orders": "ऑर्डर",
  "nav.tables": "टेबल",
  "nav.menu": "मेन्यू",
  "nav.reports": "रिपोर्ट",
  "roles.pos": "पॉइंट ऑफ़ सेल",
  "roles.kds": "किचन डिस्प्ले",
  "roles.customer": "ग्राहक डिस्प्ले",
  "roles.captain": "कैप्टन",
  "roles.kiosk": "सेल्फ-ऑर्डर कियोस्क",
  "order.dineIn": "डाइन-इन",
  "order.takeaway": "टेकअवे",
  "order.delivery": "डिलीवरी",
  "order.quickBill": "क्विक बिल",
  "order.newOrder": "नया ऑर्डर",
  "order.sendToKitchen": "किचन भेजें",
  "order.addItem": "आइटम जोड़ें",
  "order.cart": "कार्ट",
  "order.empty": "अभी कोई आइटम नहीं",
  "bill.settle": "बिल सेटल करें",
  "bill.subtotal": "उप-योग",
  "bill.discount": "छूट",
  "bill.total": "कुल",
  "bill.gst": "जीएसटी",
  "bill.customerName": "ग्राहक का नाम",
  "bill.token": "टोकन",
  "bill.billNo": "बिल नंबर",
  "bill.splitBill": "बिल बाँटें",
  "bill.splitBySeat": "सीट अनुसार बाँटें",
  "bill.pay": "भुगतान करें",
  "bill.print": "प्रिंट करें",
  "bill.paid": "भुगतान हो गया",
  "bill.pending": "लंबित",
  "table.free": "खाली",
  "table.occupied": "भरा हुआ",
  "table.transfer": "स्थानांतरित करें",
  "table.merge": "मर्ज करें",
  "settings.language": "भाषा",
  "settings.tax": "कर",
  "settings.printing": "प्रिंटिंग",
  "settings.account": "खाता और प्लान",
  "settings.general": "सामान्य",
  "settings.deviceMode": "डिवाइस मोड",
  "settings.chooseLanguage": "भाषा चुनें",
  "nav.order": "ऑर्डर",
  "nav.online": "ऑनलाइन",
  "nav.activity": "गतिविधि",
  "nav.history": "इतिहास",
  "nav.import": "इंपोर्ट",
  "nav.endShift": "शिफ्ट समाप्त करें",
  "settings.title": "सेटिंग्स",
  "settings.subtitle": "आउटलेट, कर, प्रिंटर, भूमिकाएँ और बिल फ़ॉर्मेट",
  "settings.sectionOutlet": "आउटलेट और ब्रांडिंग",
  "settings.sectionTax": "कर और जीएसटी",
  "settings.sectionPrinters": "प्रिंटर और केओटी",
  "settings.sectionRoles": "भूमिकाएँ और अनुमतियाँ",
  "settings.sectionBillFormat": "बिल फ़ॉर्मेट",
  "settings.sectionChannels": "ऑनलाइन चैनल",
  "settings.sectionAccount": "खाता और प्लान",
  "settings.sectionAbout": "परिचय और अपडेट",
  "order.viewCart": "कार्ट देखें",
  "order.categories": "श्रेणियाँ",
  "order.tapToBuild": "ऑर्डर बनाने के लिए व्यंजन टैप करें",
  "order.addNote": "नोट जोड़ें",
  "order.searchDishes": "व्यंजन खोजें",
  "bill.settleAndPrint": "सेटल करें और प्रिंट करें",
  "menu.title": "मेन्यू और आइटम",
  "menu.searchItems": "आइटम खोजें…",
  "menu.noItems": "यहाँ कोई आइटम नहीं",
  "menu.addItemBtn": "आइटम जोड़ें",
  "menu.tapAddItem": "बनाने के लिए “आइटम जोड़ें” टैप करें",
  "menu.addCategory": "श्रेणी जोड़ें",
  "menu.newCategory": "नई श्रेणी",
  "order.allFired": "सभी आइटम भेजे गए",
  "bill.settling": "सेटल हो रहा है…"
};

export default hi;
